import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_carousel = _resolveComponent("carousel")!

  return (_ctx.renderNow)
    ? (_openBlock(), _createBlock(_component_carousel, {
        key: 0,
        class: _normalizeClass(["product-box-slider product-box-slider__slider recommendations-tiles-teaser__products", `product-box-slider--itemcount_${_ctx.listItems.length}`]),
        "slides-count": _ctx.listItems.length,
        options: _ctx.swiperOptions,
        "preload-slide-count": 1,
        "show-skip-slider-link": true
      }, _createSlots({ _: 2 /* DYNAMIC */ }, [
        _renderList(_ctx.listItems, (product, index) => {
          return {
            name: `slide-${index}`,
            fn: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.productBoxComponent), {
                class: "product-box-slider__item",
                "product-box-data": product,
                "hide-counter-button": _ctx.hideCartButton,
                "tracking-additional": {
          position: index,
          list: _ctx.trackingList
        },
                "show-review": _ctx.showReview,
                state: _ctx.getProductState(product),
                onAddToBasket: _ctx.addToBasketHandler,
                onQuantityChange: _ctx.quantityChange,
                onAddToWishlist: _ctx.addToWishlistHandler,
                onRemoveFromWishlist: _ctx.removeFromWishlistHandler
              }, null, 40 /* PROPS, NEED_HYDRATION */, ["product-box-data", "hide-counter-button", "tracking-additional", "show-review", "state", "onAddToBasket", "onQuantityChange", "onAddToWishlist", "onRemoveFromWishlist"]))
            ])
          }
        })
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "slides-count", "options"]))
    : _createCommentVNode("v-if", true)
}